import React from "react";
import Routes from "./Routes";
import MockUserSwitcher from "./components/dev/MockUserSwitcher";
import { ToastProvider } from "./components/ui/Toast";

function App() {
  return (
    <ToastProvider>
      <Routes />
      {/* Renders null unless the local mock backend is active. */}
      <MockUserSwitcher />
    </ToastProvider>
  );
}

export default App;
